import {FC, MouseEvent, useEffect, useState} from 'react';

import {
    genericErrorShowToastOptions
} from '../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import {ClassBaseFormErrors, ClassBaseFormValues} from "../ClassBaseForm/ClassBaseForm.types";
import ClassBaseForm from "../ClassBaseForm/ClassBaseForm";
import UnsavedChangesModal from "../../../common/UnsavedChangesModal/UnsavedChangesModal";
import {useCreateClassBase} from "../../../services/base/base.service";
import {AxiosError} from "axios";
import {showToast} from "../../../components/Toast/Toast";
import {ToastTypes} from "../../../components/Toast/Toast.types";

const AddClassBase: FC = () => {
    const navigateWithToast = useNavigateWithToast();
    const {
      mutate: createClassBase,
      isLoading: createClassBaseIsLoading,
    } = useCreateClassBase();
    const initialFormValues = {
        classNo: undefined,
        baseNo: undefined,
    };

    const [formValues, setFormValues] = useState<ClassBaseFormValues>({
        classNo: undefined,
        baseNo: undefined,
    });

    const [formErrors, setFormErrors] = useState<ClassBaseFormErrors>({
        classNo:'',
        baseNo: '',
    });

    const validateFormValues = () => {
        let error = false;
        let errorMessages: ClassBaseFormErrors = {
            classNo:'',
            baseNo: '',
        };

        if ([null, undefined, -1].includes(formValues.classNo)) {
            errorMessages.classNo = 'Class Number is required.';
            error = true;
        }

        if ([null, undefined, -1].includes(formValues.baseNo)) {
            errorMessages.baseNo = 'Base Number is required.';
            error = true;
        }

        setFormErrors((formErrors) => {
            return { ...formErrors, ...errorMessages };
        });
        return error;
    };
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    const checkForUnsavedChanges = () => {
        if (
            initialFormValues.classNo === formValues.classNo &&
            initialFormValues.baseNo === formValues.baseNo
        ) {
            setUnsavedChanges(false);
            return;
        } else {
            setUnsavedChanges(true);
            return;
        }
    };
    useEffect(() => {
        checkForUnsavedChanges();
    }, [formValues]);

    const handleSave = (event: MouseEvent) => {
        event.preventDefault();
        const isError = validateFormValues();
        if (isError) return;
        setUnsavedChanges(false);
        createClassBase(
            {
              classId: formValues.classNo as number,
              body: {
                baseId: formValues.baseNo as number,
              }
            },
            {
                onSuccess: () => {
                    navigateWithToast(`/tables/classbases`, {
                        label: 'New ClassBase has been added successfully',
                        id: 'classbaseAddSuccess',
                    });
                },
                onError: (e) => {
                  if ((e as AxiosError)?.message === 'Request failed with status code 409') {
                    showToast({
                      label: 'ClassBase already exists.',
                      id: 'addClassBaseIsError',
                      toastType: ToastTypes.Error,
                    });
                  }
                  else {
                    showToast(genericErrorShowToastOptions);
                  }
                },
            }
        );
    };

    return (
        <>
            <ClassBaseForm
                formValues={formValues}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                setFormValues={setFormValues}
                headerTitle={'Add New ClassBase'}
                saveDisabled={!unsavedChanges}
                handleSave={handleSave}
                isButtonLoading={createClassBaseIsLoading}
            />
            <UnsavedChangesModal unsavedChangesExist={unsavedChanges} />
        </>
    );
};

export default AddClassBase;
